import { useTranslation } from "react-i18next";
import "./TraceData.scss";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ScaleLoader } from "react-spinners";
import newRequest from "../../utils/newRequest";
import { CiImageOn } from "react-icons/ci";

const TraceData = ({ documentId }) => {
    const [traceData, setTraceData] = useState([]);
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    // console.log(`documentId... ${documentId}`);
    const fetchTraceData = async () => {
        try {
            const res = await newRequest.get(`/trace/traceData/${documentId}`);
            // console.log(`fetchTraceData ${JSON.stringify(res.data, null, 2)}`);
            setTraceData(res.data);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchTraceData();
    }, [documentId]);

    return (
        <motion.div
            className="trace-data"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
        >
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
                        color="var(--primary)"
                        height={50}
                        radius={8}
                        width={4}
                    />
                </div>
            ) : (
                <div className="timeline-root">
                    {traceData.map((item) => (
                        <div key={item?._id} className="timeline-item">
                            <div className="timeline-separator">
                                <div className="timeline-dot"></div>
                                <div className="timeline-connector" />
                            </div>
                            <div className="timeline-content">
                                <div className="timeline-navbar">
                                    <div className="avatar-container">
                                        {item?.updated_by_photo_url_xx ?
                                            <img src={item?.updated_by_photo_url_xx} alt="" className="avatar" /> : <CiImageOn style={{ width: "30px", height: "30px" }} />}
                                        <span className="username">{item?.updated_by_name_xx}</span>
                                    </div>
                                    <span className="time-ago">{item?.time_ago_xx}</span>
                                </div>
                                <div className="remarks">
                                    {item?.trc_remarks}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </motion.div >
    )
};

export default TraceData